import React, { useEffect } from "react";
import { withSignalr } from "../../signalr/withSignalr";
import { compose } from "../../utils/compose";
import { connect } from "react-redux";
import { accountVerificationActions } from "../../store/actions/accountVerification/accountVerification";
import FullpageSpinner from "../../components/UI/FullpageSpinner/FullpageSpinner";
import { useTranslation } from "react-i18next";
import EmailVerification from "../../components/EmailVerification/EmailVerification";
import { makeStyles } from "@material-ui/core";
import { navigationActions } from "../../store/actions/navigation/navigation";
import AccountSetup from "../../components/AccountSetup/AccountSetup";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2)
  }
}));

const AccountVerification = props => {
  const classes = useStyles();
  const {
    signalrConnection,
    accountVerification,
    onEmailVerified,
    onSetTitle
  } = props;
  const { t, i18n } = useTranslation();

  useEffect(() => {
    signalrConnection.on("emailVerified", data => {
      onEmailVerified(data.isVerified);
    });
    console.log(signalrConnection);
  }, [signalrConnection, onEmailVerified]);

  useEffect(() => {
    onSetTitle('accountSetup');
  });

  return (
    <div className="main-container">
      <div className={classes.root}>
        {accountVerification.fetching ? (
          <FullpageSpinner />
        ) : (
          <AccountSetup />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    access_token: state.oidc.user.access_token,
    accountVerification: state.accountVerification.verificationStatus
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onEmailVerified: isVerified =>
      dispatch(accountVerificationActions.emailVerified(isVerified)),
    onSetTitle: title => dispatch(navigationActions.setTitle(title))
  };
};

const AccountVerificationComposed = compose(
  withSignalr({ hubName: "userHub" }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AccountVerification);

export default AccountVerificationComposed;
